import React, { FC } from 'react';
import { Button, Modal, Space } from 'antd';
import { IModal } from 'common/models/model.interface';
import rentalAgencyChangeService from 'common/services/rental-agency-change-service/rental-agency-change.service';
import { ReactComponent as ApproveIcon } from 'assets/icons/approve.svg';
import { notification } from 'common/utils/notification';
import styles from '../rental-portal.module.scss';

const ApproveRentalAgencyChangeModal: FC<IModal<{ agencyChangeId: number }, any>> = ({ isOpen, onClose, title, initData }) => {
  const hideModal = (isSuccess: boolean) => {
    notification.destroy();
    if (onClose) {
      onClose(isSuccess);
    }
  };

  const handleApprove = () => {
    if (!initData?.agencyChangeId) {
      console.error('Rental agency change id is empty');
      return;
    }

    rentalAgencyChangeService
      .approve(initData.agencyChangeId)
      .then(() => hideModal(true))
      .catch(() => {});
  };

  return (
    <Modal centered title={title} width={350} open={isOpen} wrapClassName="custom-modal" closable={false}>
      <Space className="confirm-modal-body">Are you sure you want to approve this authorized agent change?</Space>
      <Space className="footer">
        <Button type="link" onClick={() => hideModal(false)} className="eiq-button">
          Cancel
        </Button>
        <Button type="primary" onClick={handleApprove} icon={<ApproveIcon />} className={`${styles.approveButton} eiq-button`}>
          Approve
        </Button>
      </Space>
    </Modal>
  );
};

export default React.memo(ApproveRentalAgencyChangeModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});
